import * as yup from 'yup';
import i18n from 'i18next';

export const SignupSchema = yup.object({
  firstname: yup.string().required(i18n.t('required', { ns: 'common' })),
  surname: yup.string().required(i18n.t('required', { ns: 'common' })),
  password: yup.string().required(i18n.t('required', { ns: 'common' })),
});
